
import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { AuthService } from "@services/auth/auth-service";
import { JapaneseLabels } from "@utils/japaneseLabels";
import { AuthLoginRequest, AuthLoginResponse } from "app/models/auth.model";


/**
 * Login component.
 * Handles the display and logic for the user login page.
 */
@Component({
  selector: "app-login",
  standalone: true,

  imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule],
  templateUrl: "./login.html",
  styleUrl: "./login.scss",
})
export class Login {
  rememberMe: boolean = false;
  title = "Login";
  japaneseLabels = JapaneseLabels;
  isModalOpen = false;
  loading: boolean = false;
  success: boolean = false;
  loginForm: FormGroup;
  constructor(
    // private titleService: Title, //Service for setting the title of the page.
    private router: Router,
    private authenticateService: AuthService,
    private fb: FormBuilder
  ) {
    this.loginForm = this.fb.group({
      email: [null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      password: [null, Validators.required]
    });
  }
  /**
   * Handles the login form submission event.
   * Prevents the default form submission and processes login logic.   
   */
  onSubmit() {
    if (this.loading) return;

    // Mark all fields as touched so validation messages show
    this.loginForm.markAllAsTouched();

    if (this.loginForm.invalid) {
      return; // ❌ stop submission
    }

    const loginData: AuthLoginRequest = {
      email_address: this.loginForm.value.email,
      password: this.loginForm.value.password
    };

    this.loading = true;
    this.authenticateService.loginApi(loginData).subscribe({
      next: (response) => {

        const body: AuthLoginResponse | null = response.body;

        if (body) {
          const email_address: string = body.user_id;

          localStorage.setItem('user_id', email_address);
        }

        const accessToken: string | null = response.headers.get('Accesstoken');
        if (accessToken) {
          localStorage.setItem('accessToken', accessToken);
        }

        const token: string | null = response.headers.get('IdToken');
        if (token) {
          localStorage.setItem('token', token);
        }
        this.router.navigate(['/dashboard']); // ✅ Redirect to dashboard

        this.loading = false;
      },
      error: (error) => {

        const response: string = error.error.message;
        // console.log("response", response)

        // if (response === "User does not exist.") {
        //   alert('ログインIDまたはパスワードが正しくありません。')
        // } else if(response==="Invalid Login ID") {
        //   alert('ログインに失敗しました。もう一度お試しください。')
        // }else{
        //   alert()
        // }
        alert(response)

        this.loading = false;
      }
    });
  }

  showPassword: boolean = false;
  /**
   * hide and show password
   */
  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }
}
